import {
   ADD_DAYBOOK,
   UPDATE_DAYBOOK,
   DELETE_DAYBOOK,
   GET_DAYBOOK,
   GET_DAYBOOKS,
   GET_DAYBOOKS_FOR_MASTER,
   GET_DAYBOOKS_FOR_PAYMENTS,
   GET_ISSUE_DAYBOOK,
   GET_ONE_DAYBOOK,
   GET_PAYMENT_DAYBOOK,
   GET_ALL_DAYBOOKS,
} from '../types';

const initialState = {
   single: null,
   list: [],
   listdata: [],
   allDaybooks: [],
   listPayment: [],
   issueDaybook: [],
   paymentList: [],
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   totalCount: 0,
};

const reducer = (state = initialState, action) => {
   const { totalCount, payload } = action;
   switch (action.type) {
      case ADD_DAYBOOK:
         return {
            ...state,
            list: [...state.list, action.payload],
            totalCount: totalCount,
         };
      case UPDATE_DAYBOOK:
         return {
            ...state,
            list: state.list.map((daybook) => (daybook.id === action.payload.id ? action.payload : daybook)),
            totalCount: totalCount + 1,
         };
      case DELETE_DAYBOOK:
         return {
            ...state,
            list: state.list.filter((daybook) => daybook.id !== action.payload),
            totalCount: totalCount - 1,
         };
      case GET_DAYBOOK:
         return {
            ...state,
            single: action.payload,
         };
      case GET_DAYBOOKS:
         return {
            ...state,
            list: action.payload.data,
            pagination: payload.pagination,
         };

      case GET_DAYBOOKS_FOR_MASTER:
         return {
            ...state,
            listForMaster: action.payload.data,
            paginationForMaster: payload.pagination,
         };

      case GET_PAYMENT_DAYBOOK:
         return {
            ...state,
            paymentList: action.payload.data,
         };
      case GET_DAYBOOKS_FOR_PAYMENTS:
         return {
            ...state,
            listPayment: action.payload,
         };

      case GET_ISSUE_DAYBOOK:
         return {
            ...state,
            issueDaybook: action.payload,
         };

      case GET_ONE_DAYBOOK:
         return { ...state, single: action.payload };

      case GET_ALL_DAYBOOKS:
         return {
            ...state,
            allDaybooks: payload.data,
            pagination: payload.pagination,
            totalCount: payload.totalCount,
         };
      default:
         return state;
   }
};
export default reducer;
